export default __webpack_public_path__ + "static/media/welcome-spanish.3f1cb12b.png";